import React, { useState } from 'react';
import InviteForm from './../Tree/InviteForm';
import { downloadSvgAsImage } from './../../FamilyTree/svgUtils';
import {uploadSvgAsImageToS3} from './../../FamilyTree/SaveTreeInS3'
import logo from '../../assets/logo/full_logo.svg';
import axiosInstance from '../../axios.js';
import { API_BASE_URL } from '../../constants.js';
import { setupSvg,treeFit } from "./../../FamilyTree/view/View.handlers.js"

function AddMemberAction(props) {
  const { isOpen, onClose, onInvite, onCancel, mobile, onInputChange,familyChartElement,memberFamilyName } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const logged_in_user_obj=JSON.parse(localStorage.getItem('userData'))
  const member_id=logged_in_user_obj.user_profile.member_id?logged_in_user_obj.user_profile.member_id:""

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const loadRazorpayScript = () => {
    setModalOpen(false)
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onerror = () => {
      alert('Razorpay SDK failed to load. Are you online?');
    };
    script.onload = () => {
      handlePayment();
    };
    document.body.appendChild(script);
  };
  const initiateDownload = (include_watermark) => {
    let familyChartElement=document.getElementById("FamilyChart")
    let svg = familyChartElement.querySelector('svg');  
    const bounding={"bottom": 851.5,
      "height": 693.5,
      "left": 1.2625000476837158,
      "right": 1534.7250244617462,
      "top": 158,
      "width": 1533.4625244140625,
      "x": 1.2625000476837158,
      "y": 158}
    if (svg) {
      const tree={...window.tree}
      setupSvg(svg, undefined);
      console.log(svg.getBoundingClientRect())
      treeFit({svg, svg_dim: bounding, tree_dim: tree.dim, transition:2000})
    } 
    setTimeout(() => {
      familyChartElement=document.getElementById("FamilyChart")
      svg = familyChartElement.querySelector('svg');
      uploadSvgAsImageToS3(svg, member_id, null, memberFamilyName,'website',include_watermark,bounding);
    }, 3000);
  };
  const handlePayment = async () => {
    const mobile=logged_in_user_obj.user_profile.mobile?logged_in_user_obj.user_profile.mobile:""
    const name=logged_in_user_obj.member_details.first_name?logged_in_user_obj.member_details.first_name:""
    const email=logged_in_user_obj.user_profile.email?logged_in_user_obj.user_profile.email:""
    const options = {
      // key: "rzp_test_7RfoGSX7wL59Yg", // Enter your Razorpay Key ID
      key: "rzp_live_CFQGb2uIBGPR49",
      amount: 7200, // Amount is in paise, e.g., 50000 paise = ₹500
      currency: "INR",
      name: "Memyfolks",
      description: "Download Tree without Watermark",
      image: logo,
      order_id: "", // You can generate the order_id via backend API
      handler: function (response) {
        console.log(response)
        alert(`Payment Successful. Please note Payment ID: ${response.razorpay_payment_id} for further correspondence.`);
        initiateDownload(true);
      },
      prefill: {
        name: name,
        email: email,
        contact: mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
        member_id:member_id
      },
      theme: {
        color: "#F37254",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };


  const handleInvite = () => {
    axiosInstance.get(API_BASE_URL+"check-subscription/"+member_id+"/").then((response)=>{
      console.log(response.data.is_subscriber);
      if(response.data){
        if(response.data.is_subscriber==true){
          initiateDownload(true);
        }
        else{
            setModalOpen(true)
        }
      }
});    
  };

  const handleWatermarkDownload = () => {
    setModalOpen(false);
    initiateDownload(false);

  };
  const handleCancel = () => {
    console.log('Cancel button clicked');
    closeModal(); 
  };

  const handleInputChange = (e) => {
    onInputChange(e);
  };

  const svgContent = ` <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <path d="M20 19V17H4V19H20M12 2C12.55 2 13 2.45 13 3V13.35L15.79 10.57L17.21 11.99L12 17.21L6.79 11.99L8.21 10.57L11 13.36V3C11 2.45 11.45 2 12 2Z" />
</svg>
`;

  // Convert SVG content to a data URI
  const svgDataUri = `data:image/svg+xml,${encodeURIComponent(svgContent)}`;



  return (
    <div>
      <button className="download-btn" onClick={handleInvite}>
        <img src={svgDataUri} alt="SVG as Image" />
      </button>
      <InviteForm
        isOpen={isModalOpen}
        onClose={closeModal}
        onInvite={handleInvite}
        onCancel={handleCancel}
        mobile={mobile}
        onInputChange={handleInputChange}
        loadRazorpayScript={loadRazorpayScript}
        handleWatermarkDownload={handleWatermarkDownload}
      />
    </div>
  );
}

export default AddMemberAction;
